import { Link } from '@inertiajs/inertia-vue3';
export default {
  components: {
    Link: Link
  },
  props: {
    links: Array
  }
};